import { ReactNode } from 'react';

import { updateApplicantProfile } from 'modules/main/store/ducks/userEnvironment';
import { useMainDispatch } from 'modules/main/store/hooks/useMainDispatch';
import { useUserEnvironment } from 'modules/main/store/hooks/useUserEnvironment';
import { dismissResumeDBLoggedOut } from 'utils/resumeDatabase';

const ResumeDatabaseResponseContainer = ({
  children,
}: {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: (arg0: { dismiss: (...args: Array<any>) => any }) => ReactNode;
}) => {
  const { user } = useUserEnvironment();
  const dispatch = useMainDispatch();

  const dismiss = () => {
    if (user) {
      dispatch(
        updateApplicantProfile({
          isRecruitable: false,
        })
      );
    } else {
      dismissResumeDBLoggedOut();
    }
  };

  return children({
    dismiss,
  });
};

// eslint-disable-next-line import/no-default-export
export default ResumeDatabaseResponseContainer;
